/* src/app/ai-sourcing/ai-sourcing-profile-skeleton/ai-sourcing-profile-skeleton.component.scss */
/*# sourceMappingURL=ai-sourcing-profile-skeleton.component-SCNBSNJU.css.map */
